import React, { useState, useEffect } from 'react';
import { getTopics } from '../services/api';
import './Sidebar.css';

const Sidebar = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTopic, setActiveTopic] = useState(null);

  useEffect(() => {
    fetchTopics();
  }, []);

  useEffect(() => {
    if (topics.length === 0) return;

    // Scroll spy - update active topic as user scrolls
    const handleScroll = () => {
      const topicElements = topics.map(topic => ({
        id: topic.id,
        element: document.getElementById(`topic-${topic.id}`)
      })).filter(item => item.element);

      if (topicElements.length === 0) return;

      const scrollPosition = window.scrollY + 100; // Offset for header

      for (let i = topicElements.length - 1; i >= 0; i--) {
        const { id, element } = topicElements[i];
        const elementTop = element.offsetTop;
        
        if (scrollPosition >= elementTop) {
          setActiveTopic(id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount

    return () => window.removeEventListener('scroll', handleScroll);
  }, [topics]);

  const fetchTopics = async () => {
    try {
      const response = await getTopics();
      // Sort topics by order_index
      const sortedTopics = response.data.sort((a, b) => {
        if (a.order_index !== b.order_index) {
          return (a.order_index || 0) - (b.order_index || 0);
        }
        return a.name.localeCompare(b.name);
      });
      setTopics(sortedTopics);
    } catch (error) {
      console.error('Error fetching topics:', error);
    } finally {
      setLoading(false);
    }
  };

  const scrollToTopic = (topicId) => {
    setActiveTopic(topicId);
    
    // Dispatch custom event to expand the topic
    window.dispatchEvent(new CustomEvent('expandTopic', { detail: { topicId } }));
    
    // Scroll to the topic
    setTimeout(() => {
      const element = document.getElementById(`topic-${topicId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Add a small offset for the fixed header
        setTimeout(() => {
          window.scrollBy(0, -80);
        }, 100);
      }
    }, 100);
  };

  if (loading) {
    return (
      <aside className="sidebar">
        <div className="sidebar-loading">Loading...</div>
      </aside>
    );
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Topics</h2>
      </div>
      <div className="sidebar-content">
        {topics.map(topic => (
          <div 
            key={topic.id} 
            className={`topic-item ${activeTopic === topic.id ? 'active' : ''}`}
            onClick={() => scrollToTopic(topic.id)}
          >
            <span className="topic-name">{topic.name}</span>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;

